import React from 'react'
import { VGKFields, partnershipValues } from '../configs'
import { Grid, MenuItem, Select, TextField, Typography } from '@mui/material'


export default function PartnershipField({ partnershipField, campaignDetailsRef, show_how_did_you_hear }) {

    let partnerships = partnershipValues

    if (partnershipField == 'vgk') {
        Object.keys(partnerships).forEach(ele => {
            if (VGKFields.includes(ele) == false) {
                delete partnerships[ele]
            }
        })
    }

    return (
        <Grid item xs={12} sm={6} sx={{ p: 2, py: 1 }}>
            <Typography sx={{ color: "white" }}>How Did You Hear About VBG?</Typography>
            <Select
                displayEmpty
                required={show_how_did_you_hear == true ? true : false}
                fullWidth
                size="small"
                inputRef={campaignDetailsRef}
                sx={{ background: "white", borderRadius: 1 }}
                defaultValue=""
            >
                <MenuItem value="">-- Please Choose an Option --</MenuItem>

                {
                    Object.keys(partnerships).map((ele, index) => {
                        return (
                            <MenuItem key={`${ele}-${index}`} value={ele} >{ele}</MenuItem>
                        )
                    })
                }
            </Select>
        </Grid>
    )
}


